export default __webpack_public_path__ + "static/Fotolia_57295439_M-2fc1db5cf32a388edab651cc8a18645c.jpg";